import React, { useState, useEffect,} from 'react';
import { Play } from "lucide-react";
import {Card, Button, CardText, } from 'react-bootstrap';
import { Link, useParams, useNavigate } from 'react-router-dom';
import MainTPlayer from '../MainTPlayer' ;
import AH from '../assets/titleimage.jpg';
import MovieList from '../MovieList';
import NewMovies from '../NewMovies';
import HitchcockMovies from '../HitchcockMovies';
import HeroBackgroundVideo from '../HeroBackgroundVideo';
import HeroBackground from '../HeroBackground';
import { useOnScreen } from '../useOnScreen';

function Home() {
  const [error, setError] = useState(null);
  const [selectedTab, setSelectedTab] = useState(null);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [movies, setMovies] = useState([]);
  const { moviename: movieParam } = useParams();
  const [movieData, setMovieData] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);

  const [resumeData, setResumeData] = useState(null);
  const navigate = useNavigate();

      const [showBottom, setShowBottom] = useState(false);

        const [newMoviesRef, newMoviesVisible] = useOnScreen();
  const [movieListRef, movieListVisible] = useOnScreen();
  const [hitchcockRef, hitchcockVisible] = useOnScreen();
    
  
    useEffect(() => {
      const t = setTimeout(() => setShowBottom(true), 2300);
      return () => clearTimeout(t);
    }, []);

  useEffect(() => {
    const saved = localStorage.getItem('resumeData');
    if (saved) {
      setResumeData(JSON.parse(saved));
    }
  }, []);

  const handleResume = () => {
    if (resumeData) {
      const { moviename, time } = resumeData;  // moviename is from localStorage data keys
      navigate(`/${moviename}?time=${time}`);
    }
  };
  


  useEffect(() => {
    const handleBodyClick = (event) => {
      if (selectedTab && !event.target.closest('.expanded-content')) {
        setSelectedTab(null);
        setIsFullScreen(false);
      }
    };

    document.body.addEventListener('click', handleBodyClick);

    return () => {
      document.body.removeEventListener('click', handleBodyClick);
    };
  }, [selectedTab]);

  useEffect(() => {
    const fetchMovieData = async () => {
      try {
        const response = await fetch(`https://second-team-productions.onrender.com/newmovies`);
        if (!response.ok) {
          throw new Error('Failed to fetch movie data');
        }
        const data = await response.json();
        const filteredMovies = data.filter(movie => movie.moviename === 'SEVEN SAMURAI');
        if (filteredMovies.length > 0) {
          setMovieData(filteredMovies[0]);
          setIsLoaded(true);
        } else {
          throw new Error('Movie data not found');
        }
      } catch (error) {
        console.error('Error fetching movie data:', error);
        setError(error.message);
      }
    };

    fetchMovieData();
  }, [movieParam]);

  useEffect(() => {
  if (isLoaded) {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });

    const timeout = setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, 100);

    return () => clearTimeout(timeout);
  }
}, [isLoaded]);


  return (
    <div 
    style={{ 
      justifyContent: 'center', 
      alignItems: 'center',
    }}
      >
        <HeroBackgroundVideo 
  video="2ndTeamLogoV1.mp4" 
  bgColor="#131212" 
/>
   {/* <HeroBackground 
   image="allbg.jpg"  
   bgColor="#131212" /> */}
      <div
      style={{
        marginRight: '3.5%',
        marginLeft: '3.5%',
        // marginTop: '4%',
        borderRadius: '10px',
         opacity: showBottom ? 1 : 0,
    transition: "opacity 0.6s ease",
     transitionDelay: "0s",
       backdropFilter: 'blur(8px)',
  WebkitBackdropFilter: 'blur(8px)',
  borderRadius: "30px",
  border: '2px solid rgba(28, 26, 26, 0.9)',
boxShadow: `
  0 2px 0 rgba(255, 255, 255, 0.03) inset,
  0 -2px 0 rgba(0, 0, 0, 0.5) inset,
  0 12px 24px rgba(0, 0, 0, 0.6),
  0 32px 64px rgba(0, 0, 0, 0.5),
  0 64px 100px rgba(0, 0, 0, 0.35)
`,
      }}
      >    
        <MainTPlayer/>  
      </div>
      <div> 
        <div
              style={{
                  marginRight: '3%',
        marginLeft: '3%',
         marginTop: '1%',
         opacity: showBottom ? 1 : 0,
    transition: "opacity 0.6s ease",
     transitionDelay: ".5s",
      }}
        >  
           <NewMovies movies={movies} setMovies={setMovies} title=" New Movies" />
        </div>
      <div
        style={{
            marginRight: '3%',
        marginLeft: '3%',
        marginTop: '1%',
         opacity: showBottom ? 1 : 0,
    transition: "opacity 0.6s ease",
     transitionDelay: "1s"
      }}>
       
           <MovieList movies={movies} setMovies={setMovies} title="Movies" />
      </div>
       <div
        style={{
            marginRight: '3%',
        marginLeft: '3%',
        marginTop: '1%',
         opacity: showBottom ? 1 : 0,
    transition: "opacity 0.6s ease",
     transitionDelay: "1.5s"
      }}>
       
            <HitchcockMovies movies={movies} setMovies={setMovies} title=" Hitchcock Movies" />
      </div>
      <br></br>
      </div>
    </div>
  );
}

export default Home;
